import { urlFactory } from '../helpers'
import { fetchPosts } from './postActions'

const eventDateDetailsRequested = (store, eventDateId) => {
    const eventDateDetails = {
        ...store.getState().eventDateDetails,
        [eventDateId]: {
            isFetching: true,
            data: null,
            error: false
        }
    }

    store.setState({
        eventDateDetails
    })
}

const eventDateDetailsReceived = (store, eventDateId, eventDateDetail) => {
    const eventDateDetails = {
        ...store.getState().eventDateDetails,
        [eventDateId]: {
            isFetching: false,
            data: eventDateDetail,
            error: false
        }
    }

    store.setState({
        eventDateDetails
    })
}

const eventDateDetailsError = (store, eventDateId) => {
    const eventDateDetails = {
        ...store.getState().eventDateDetails,
        [eventDateId]: {
            isFetching: false,
            data: null,
            error: true
        }
    }

    store.setState({
        eventDateDetails
    })
}

export const fetchEventDateDetails = (store, eventDateId) => {
    const eventDateDetails = store.getState().eventDateDetails[eventDateId]
    if (eventDateDetails && (eventDateDetails.isFetching || eventDateDetails.data))
        return

    eventDateDetailsRequested(store, eventDateId)

    const config = store.getState().config
    const url = urlFactory.getEventDateDetails(config, eventDateId)
    fetch(url, {
        method: 'GET',
        headers: { 'Accept': 'application/json' }
    })
        .then(response => {
            if (response.ok) {
                response.json().then(eventDateDetails => {
                    eventDateDetailsReceived(store, eventDateId, eventDateDetails);
                    if(config.hasPosts)
                        fetchPosts(store, eventDateDetails.tags, eventDateId)
                })
            } else {
                eventDateDetailsError(store, eventDateId)
            }
        })
        .catch(err => {
            console.error(err)
            eventDateDetailsError(store)
        })
}

export const showEventDateDetails = (store, eventDateId) => {
    const eventDateDetailShown = store.getState().eventDateDetailShown

    store.setState({
        eventDateDetailShown: eventDateDetailShown === eventDateId ? null : eventDateId,
        eventDateMenuShown: null
    })
}

export const showEventDateMenu = (store, eventDateId) => {
    const eventDateMenuShown = store.getState().eventDateMenuShown

    store.setState({
        eventDateMenuShown: eventDateMenuShown === eventDateId ? null : eventDateId,
        eventDateDetailsShown: null
    })
}

export const showEventDateMinimalDetails = (store, eventDateId) => {
    const eventDateDetailMinimalShown = store.getState().eventDateDetailMinimalShown

    store.setState({
        eventDateDetailMinimalShown: eventDateDetailMinimalShown === eventDateId ? null : eventDateId,
        eventDateModalMenuShown: null
    })
}

export const showEventDateModalMenu = (store, eventDateId) => {
    const eventDateModalMenuShown = store.getState().eventDateModalMenuShown

    store.setState({
        eventDateModalMenuShown: eventDateModalMenuShown === eventDateId ? null : eventDateId
    })
}
